module.exports = __webpack_public_path__ + "static/media/Mapa-Mato Grosso do Sul.d3dd540b.svg";